export default __webpack_public_path__ + "static/MineralSwimV2_Testimonial_3-6c0625815303f7f768e22a1ff2421744.jpg";